import React from "react";
import { Box, Typography, Stack } from "@mui/material";

/**
 * MagazineSectionContainer
 * 하단 보더와 반응형 패딩을 공통 적용하는 섹션 래퍼
 *
 * Props:
 * @param {React.ReactNode} children - 섹션 내용 [Required]
 * @param {object} [sx] - 추가 sx 스타일 [Optional]
 * @param {string} [borderColor='primary.main'] - 보더 색상 [Optional]
 * @param {string} [title] - 섹션 타이틀 [Optional]
 * @param {'left'|'center'|'right'} [titleAlign='left'] - 타이틀 정렬 [Optional]
 * @param {boolean} [isMobile] - 모바일 여부 [Optional]
 */
const MagazineSectionContainer = ({
	children,
	sx,
	borderColor = "primary.main",
	title,
	titleAlign = "left",
	isMobile,
}) => {
	return (
		<Stack
			spacing={0}
			sx={{
				width: "100%",
				borderBottom: "1px solid",
				borderColor,
				overflowY: "hidden",
				overflowX: "visible",
				...sx,
			}}
		>
			{title ? (
				<Box sx={{ borderBottom: "1px solid", borderColor }}>
					<Typography
						variant={isMobile ? "h6" : "h5"}
						align={titleAlign}
						sx={{
							p: isMobile ? 0.5 : 1,
							wordBreak: "keep-all",
							backgroundColor: "primary.main",
							color: "white",
							fontWeight: 800,
							width: "fit-content",
							fontSize: isMobile ? "1rem" : undefined,
							fontFamily:
								'"source-han-serif-korean", "Noto Serif KR", "Noto Serif CJK KR", "Source Han Serif KR", "Apple SD Gothic Neo", "Malgun Gothic", "맑은 고딕", serif',
						}}
					>
						{title}
					</Typography>
				</Box>
			) : null}
			<Box>{children}</Box>
		</Stack>
	);
};

export default MagazineSectionContainer;
